module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dis-result"
  }, [_c('div', {
    staticClass: "i-menu"
  }, [_c('div', {
    staticClass: "iterm-l web-iterm quickTool",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.quickFile = !_vm.quickFile
      }
    }
  }, [_vm._v("\n      快速引入\n      "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quickFile),
      expression: "quickFile"
    }],
    staticClass: "drop-down-content"
  }, [_c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.quickTool()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("基础代码模版")])])])]), _vm._v(" "), _c('ul', _vm._l((_vm.menus), function(item, index) {
    return _c('li', {
      class: {
        active: index == _vm.n
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0), _vm._v(" "), (_vm.compileBtn) ? _c('div', {
    staticClass: "run"
  }, [_c('div', {
    staticClass: "click-run",
    on: {
      "click": _vm.compile
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "i-content"
  }, [(_vm.n == 0) ? _c('div', {
    staticClass: "tab stdin-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.standand),
      expression: "standand"
    }],
    staticClass: "effect-2",
    attrs: {
      "type": "text",
      "placeholder": "标准输入"
    },
    domProps: {
      "value": (_vm.standand)
    },
    on: {
      "keyup": _vm.inputParam,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.standand = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "focus-border"
  })]) : _vm._e(), _vm._v(" "), (_vm.n == 1) ? _c('div', {
    staticClass: "tab"
  }, [_c('pre', {
    staticClass: "compile-info",
    domProps: {
      "innerHTML": _vm._s(_vm.conetent)
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-026585fc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItermV2/index.vue
// module id = 502
// module chunks = 1